import { render } from "./SettingsComponent.vue?vue&type=template&id=28b4cd19"
import script from "./SettingsComponent.vue?vue&type=script&lang=js"
export * from "./SettingsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/settings/SettingsComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "28b4cd19"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('28b4cd19', __exports__)) {
    api.reload('28b4cd19', __exports__)
  }
  
  module.hot.accept("./SettingsComponent.vue?vue&type=template&id=28b4cd19", () => {
    api.rerender('28b4cd19', render)
  })

}


export default __exports__